import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class FormatCriteria extends BasicCriteria {
formatType: string;
}

